/**
 * What this product is called, and the artwork that says so.
 *
 * In one file because the name appears in four unrelated places — the
 * sidebar, the sign-in page, the browser tab and anything that prints —
 * and a rename that reaches three of them is worse than one that reaches
 * none.
 *
 * The lockups are artwork, not text. They have their own letterforms and
 * two colours; rebuilding them in CSS would be a drawing of a logo rather
 * than the logo. Anywhere one is used, the name goes in `alt` so it is
 * still readable to a screen reader, a text browser, or a printed page
 * with images turned off.
 *
 * NOT TRANSLATED
 * The name stays Latin in Arabic, as product names generally do and as
 * the artwork itself requires — there is no Arabic lockup. The words
 * around it are translated as usual.
 */

export const PRODUCT_NAME = 'My Books by CFOAI';

/** For the browser tab, where the organisation's name goes in front. */
export const PRODUCT_SHORT = 'My Books';

export const BRAND = {
  /** Mark and wordmark, for a navy background. The sidebar. */
  lockupDark: '/brand/my-books-logo-dark.png',
  /** Mark and wordmark, for a light background. The sign-in page. */
  lockupLight: '/brand/my-books-logo.png',
  /** The mark alone, for the collapsed sidebar and the browser tab. */
  mark: '/brand/my-books-mark.png',
} as const;
